import Container from '@/Components/Marketing/Container';
import { RING_SURFACE } from '@/Components/Marketing/focusRing';
import Tone from '@/Components/Marketing/Tone';
import { cn } from '@/lib/utils';

// Each surface also names its focus rings' offset (focusRing.js); a band
// that paints another colour over its section names that one's instead.
const SURFACES = {
    light: { className: `bg-mk-canvas text-mk-ink ${RING_SURFACE.canvas}`, tone: 'light' },
    surface: { className: `bg-mk-surface text-mk-ink ${RING_SURFACE.surface}`, tone: 'light' },
    sunken: { className: `bg-mk-sunken text-mk-ink ${RING_SURFACE.sunken}`, tone: 'light' },
    dark: { className: `bg-mk-night text-mk-night-text ${RING_SURFACE.night}`, tone: 'dark' },
};

/**
 * A full-width page band. `tone` picks the surface (light | surface | sunken |
 * dark) and hands light/dark down to every primitive inside it. Content sits
 * in the standard `Container` unless `bleed` is set, for bands that run edge to
 * edge. Extra props (aria-labelledby, ...) land on the <section>.
 */
export default function Section({
    tone = 'light',
    bleed = false,
    id,
    className,
    containerClassName,
    children,
    ...props
}) {
    const surface = SURFACES[tone] ?? SURFACES.light;

    return (
        <section id={id} className={cn('py-24 sm:py-32', surface.className, className)} {...props}>
            <Tone tone={surface.tone}>
                {bleed ? children : <Container className={containerClassName}>{children}</Container>}
            </Tone>
        </section>
    );
}
